<template>
  <div class="catalog-page">
    <section class="catalog-hero">
      <v-container>
        <span>CATÁLOGO AGUILA PRINT</span>
        <h1>{{ activeCategory ? activeCategory.name : 'Productos personalizados' }}</h1>
        <p>Encuentra una base, envíanos tu idea y la convertimos en un producto único.</p>
      </v-container>
    </section>

    <v-container class="catalog-content">
      <div class="catalog-toolbar">
        <div><h2>{{ products.length }} productos</h2><p v-if="activeCategory">Categoría seleccionada: {{ activeCategory.name }}</p></div>
        <v-text-field v-model="inputSearch" outlined dense clearable hide-details prepend-inner-icon="mdi-magnify" label="Buscar por nombre, marca o descripción" class="search-field" />
      </div>

      <v-row v-if="loading">
        <v-col v-for="n in 8" :key="n" cols="12" sm="6" lg="4" xl="3"><v-skeleton-loader type="image, article, button" /></v-col>
      </v-row>

      <v-row v-else-if="filteredProducts.length">
        <v-col v-for="product in filteredProducts" :key="product.id" cols="12" sm="6" lg="4" xl="3">
          <ProductCard :product_id="product.id" :brand="product.brand || ''" :name="product.name" :price="product.price" :stock="Number(product.stock || 0)" :img="product.photo" :description="product.description || ''" />
        </v-col>
      </v-row>

      <v-alert v-else type="info" text border="left" class="mt-8">No encontramos productos con esos criterios.</v-alert>
    </v-container>
  </div>
</template>

<script>
import ProductCard from "../../components/Product.vue";
import { mapState } from "vuex";
export default {
  name: "ProductCatalog",
  components: { ProductCard },
  data: () => ({ products: [], inputSearch: "", page: 0, loading: false }),
  computed: {
    ...mapState(["activeCategory"]),
    filteredProducts() {
      const query = (this.inputSearch || "").trim().toLowerCase();
      return this.products.filter(p => Number(p.stock) !== 0).filter(p => {
        if (!query) return true;
        return [p.name, p.brand, p.description].some(value => String(value || "").toLowerCase().includes(query));
      });
    },
  },
  watch: { activeCategory: { handler(value) { this.inputSearch = ""; value ? this.loadCategoryProducts(value.id) : this.loadInitialProducts(); }, immediate: false } },
  methods: {
    loadInitialProducts() { this.loading = true; this.$axios.get(`/api/product/${this.page}`).then(res => { this.products = (res.data && res.data.data) || []; }).catch(error => console.error(error)).finally(() => { this.loading = false; }); },
    loadCategoryProducts(id) { this.loading = true; this.$axios.get(`/api/sub-category-product/${id}`).then(res => { this.products = (res.data && res.data.data) || []; }).catch(error => console.error(error)).finally(() => { this.loading = false; }); },
  },
  created() { this.activeCategory ? this.loadCategoryProducts(this.activeCategory.id) : this.loadInitialProducts(); },
};
</script>

<style scoped>
.catalog-page{min-height:100vh;background:#f8f7fb}.catalog-hero{padding:55px 0;background:linear-gradient(135deg,#4f0b78,#8d32c6);color:#fff}.catalog-hero span{font-size:12px;font-weight:900;letter-spacing:.16em}.catalog-hero h1{margin:10px 0 8px;font-size:clamp(32px,5vw,52px)}.catalog-hero p{margin:0;color:rgba(255,255,255,.78);font-size:17px}.catalog-content{padding-top:42px;padding-bottom:70px}.catalog-toolbar{display:flex;align-items:center;justify-content:space-between;gap:25px;margin-bottom:28px}.catalog-toolbar h2{margin:0;font-size:26px}.catalog-toolbar p{margin:4px 0 0;color:#777}.search-field{max-width:480px;background:#fff}.search-field>>>.v-input__slot{border-radius:12px!important}@media(max-width:700px){.catalog-toolbar{align-items:stretch;flex-direction:column}.search-field{max-width:none}}
</style>
